"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultHeadingState = void 0;
exports.defaultHeadingState = {
    heading: '2,494 Properties for rent in Hong Kong',
    tFormat: {
        heading: '{0} Properties for {1} in {2}',
        buy: 'Buy',
        rent: 'Rent',
        hongKong: 'Hong Kong',
        thisSearch: 'this search',
    },
    isSaved: false,
};
